export const QUERY_KEYS = {
  DASHBOARD_METRICS: 'dashboard-metrics',
  WINGMAN_METRICS: 'wingman-metrics',
  EVENT_METRICS: 'event-metrics',
  MODERATION_QUEUE: 'moderation-queue',
  MODERATION_CASE_DETAILS: 'moderation-case-details',
  EVENTS_LIST: 'events-list',
  EVENT_REVIEWS: 'event-reviews',
  PARTNER_EVENTS_LIST: 'partner-events-list',
  PARTNER_DASHBOARD: 'partner-dashboard',
  ADMIN_USERS: 'admin-users',
  PARTNERS_LIST: 'partners-list',
  PORTAL_NOTIFICATIONS: 'portal-notifications',
  PARTNER_COMPANY_INFO: 'partner-company-info',
  PARTNER_PLANS: 'partner-plans',
  VETTING_APPLICATIONS: 'vetting-applications',
  VETTING_CONFIG: 'vetting-config',
  APP_USERS: 'app-users',
  ARIA_ESCALATIONS: 'aria-escalations',
};

export const dashboardQueryKeys = {
  all: [QUERY_KEYS.DASHBOARD_METRICS],
  metrics: (startDate, endDate) => [QUERY_KEYS.DASHBOARD_METRICS, startDate, endDate],
};

export const wingmanQueryKeys = {
  all: [QUERY_KEYS.WINGMAN_METRICS],
  metrics: (startDate, endDate) => [QUERY_KEYS.WINGMAN_METRICS, startDate, endDate],
};

export const moderationQueryKeys = {
  all: [QUERY_KEYS.MODERATION_QUEUE],
  queue: () => [QUERY_KEYS.MODERATION_QUEUE],
  caseDetails: (caseId) => [QUERY_KEYS.MODERATION_CASE_DETAILS, caseId],
};

export const eventMetricsQueryKeys = {
  all: [QUERY_KEYS.EVENT_METRICS],
  metrics: () => [QUERY_KEYS.EVENT_METRICS],
};

export const eventsQueryKeys = {
  all: [QUERY_KEYS.EVENTS_LIST],
  list: (params) => [QUERY_KEYS.EVENTS_LIST, params],
  detail: (eventId) => [QUERY_KEYS.EVENTS_LIST, 'detail', eventId],
  reviews: (eventId) => [QUERY_KEYS.EVENT_REVIEWS, eventId ?? 'all'],
};

export const eventReviewsQueryKeys = {
  all: [QUERY_KEYS.EVENT_REVIEWS],
  list: (eventId) => [QUERY_KEYS.EVENT_REVIEWS, eventId ?? 'all'],
};

export const partnerEventsQueryKeys = {
  all: [QUERY_KEYS.PARTNER_EVENTS_LIST],
  list: (params) => [QUERY_KEYS.PARTNER_EVENTS_LIST, params],
  detail: (eventId) => [QUERY_KEYS.PARTNER_EVENTS_LIST, 'detail', eventId],
};

export const partnerDashboardQueryKeys = {
  all: [QUERY_KEYS.PARTNER_DASHBOARD],
};

export const adminQueryKeys = {
  all: [QUERY_KEYS.ADMIN_USERS],
  users: (params) => [QUERY_KEYS.ADMIN_USERS, params],
};

export const partnerQueryKeys = {
  all: [QUERY_KEYS.PARTNERS_LIST],
  list: (params) => [QUERY_KEYS.PARTNERS_LIST, params],
};

export const partnerCompanyInfoQueryKeys = {
  all: [QUERY_KEYS.PARTNER_COMPANY_INFO],
  detail: (partnerId = 'current') => [QUERY_KEYS.PARTNER_COMPANY_INFO, partnerId],
};

export const partnerPlansQueryKeys = {
  all: [QUERY_KEYS.PARTNER_PLANS],
};

export const vettingApplicationQueryKeys = {
  all: [QUERY_KEYS.VETTING_APPLICATIONS],
  list: (params) => [QUERY_KEYS.VETTING_APPLICATIONS, params],
  detail: (applicationId) => [QUERY_KEYS.VETTING_APPLICATIONS, 'detail', applicationId],
};

export const vettingConfigQueryKeys = {
  all: [QUERY_KEYS.VETTING_CONFIG],
  active: () => [QUERY_KEYS.VETTING_CONFIG, 'active'],
};

export const appUsersQueryKeys = {
  all: [QUERY_KEYS.APP_USERS],
  list: (params) => [QUERY_KEYS.APP_USERS, params],
};

export const ariaEscalationQueryKeys = {
  all: [QUERY_KEYS.ARIA_ESCALATIONS],
  list: (params) => [QUERY_KEYS.ARIA_ESCALATIONS, params],
};

export const portalNotificationsQueryKeys = {
  all: [QUERY_KEYS.PORTAL_NOTIFICATIONS],
  list: (userRole, typesKey) => [QUERY_KEYS.PORTAL_NOTIFICATIONS, userRole, typesKey],
  infinite: (userRole, limit) => [QUERY_KEYS.PORTAL_NOTIFICATIONS, 'infinite', userRole, limit],
};
